module.exports = __webpack_public_path__ + "static/media/bg1.74aaeeb9.jpg";